import { render, staticRenderFns } from "./CommissionDistributionRuleSetList.vue?vue&type=template&id=d624b308"
import script from "./CommissionDistributionRuleSetList.vue?vue&type=script&lang=js"
export * from "./CommissionDistributionRuleSetList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports